import { faCircleCheck } from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Ordenacao } from "app/api/classes/AtendimentoClienteApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Atendimentos } from "app/types/cliente/DadosAtendimento";
import { FiltrosAtendimento } from "app/types/cliente/FiltrosAtendimento";
import { IColuna } from "app/types/IColuna";
import { Vendedor } from "app/types/Vendedor";
import { FormikErrors, useFormik } from "formik";
import * as R from 'ramda';
import globalMU from "globalMU";
import React, { useEffect, useState } from "react";
import { AcoesHeadAtendimento } from "./TableHead/AcoesHeadAtendimento";
import { HeaderAtendimento } from "./TableHead/HeaderAtendimento";
import { Separador } from "../separador/Separador";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";
import { SelecaoComFiltro } from "../selecao-com-filtro/SelecaoComFiltro";
import { InputData } from "../inputs/InputData";
import { TooltipMU } from "../tooltip/TooltipMU";

const estiloTabela = require('../../estilos/tabelas.module.scss').default
const estiloBotoes = require('../../estilos/botoes.module.scss').default
const estiloInputs = require('../../estilos/inputs.module.scss').default

export type EntitiesAtendimento = {
  atividade: string;
  cliente: string;
  codigo: number;
  contato: string;
  data: string;
  dataProximoContato: string;
  lido: boolean;
  motivo: string;
  telefone: string;
  vendedor: string;
  texto: string;
};

export type InformacaoAtendimento = {
  codigoCliente: number;
  codigoVendedor: string;
  dataFinal: string;
  dataFinalProximoContato: string;
  dataInicial: string;
  dataInicialProximoContato: string;
  nomeCliente: string;
  numeroPagina: number;
  ordenacao: string;
  somenteNaoLidos: boolean;
  tamanhoPagina: number;
  permitidoAlterarCliente: boolean;
};

export type AtendimentoProps = {
  foraOrcamento?: boolean
  vendedorLogado: Vendedor
  ordenacao: Ordenacao[];
  vendedores: Vendedor[];
  dadosAtendimento: Partial<PagedMessageResponse<Atendimentos>>;
  informacaoAtendimento: FiltrosAtendimento;
  onPesquisarVendedor: (nome: string) => void;
  onNovo: () => void;
  onPesquisar: (informacaoAtendimento: FiltrosAtendimento) => void;
  onAlterarFonte: (tamanho: number) => void;
  onColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
  onSelecionarTodasColunas: (selecionar: boolean) => void;
  onPesquisarCliente: (filtrosAtendimento: FiltrosAtendimento) => void
  onDefinirLeituraAtendimento: (codigoAtendimento: number, lido: boolean) => void
  onLimparCliente: () => void
  tamanhoFontePadrao: number;
  permiteEngrenagemGrid: boolean
  colunas: IColuna[];
  possuiCliente: boolean
  onErrorValidacao: (erros: FormikErrors<FiltrosAtendimento>) => void
  permiteIncluirAtendimento?: boolean // 489353
};


export const Atendimento = (props: AtendimentoProps) => {

  const [formularioValidado, setFormularioValidado] = useState<boolean>(false)
  const [carregandoVendedor, setCarregadoVendedor] = useState(false)

  const formik = useFormik({
    initialValues: { ...props.informacaoAtendimento },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
    validate: (values) => {

      const mensagemDataMenor = (campo1: string, campo2: string) => `O campo  "${campo1}" não pode ser maior do que a "${campo2}".`
      return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
        DataInicial: values.DataInicial != undefined && values.DataFinal != undefined
                    &&  new Date(values.DataInicial).getTime() > new Date(values.DataFinal).getTime() 
            ? mensagemDataMenor("Data Inicial", "Data Final") 
            : undefined,
        DataInicialProximoContato: 
            values.DataFinalProximoContato != undefined && values.DataInicialProximoContato != undefined 
                      && new Date(values.DataInicialProximoContato).getTime() > new Date(values.DataFinalProximoContato).getTime()
              ? mensagemDataMenor("Data Inicial Próx. Contato", "Data Final Próx. Contato") 
              : undefined,
      } as FormikErrors<FiltrosAtendimento>)
    }
  });

  const itensAtendimento = ({ nomeColuna, atendimento }: { nomeColuna: string, atendimento: Atendimentos }) => {

    const fn = R.cond([
      [R.equals("Lido"), _ =>
        <td> <FontAwesomeIcon
          style={{ margin: "7px 0 7px 0" }}
          color={atendimento.Lido ? "#00c800" : "#bbbbbb"}
          fontSize={"20px"}
          icon={faCircleCheck}
          onClick={() => props.onDefinirLeituraAtendimento(atendimento.Codigo, !atendimento.Lido)} // 444842
        /></td>],
      [R.equals("Data"), _ => <td>{globalMU.formatDateTime(atendimento.Data)}</td>],
      [R.equals("DataProximoContato"), _ => <td>{globalMU.formatDateTime(atendimento.DataProximoContato)}</td>],
      [R.equals("Contato"), _ => <td>{atendimento.Contato}</td>],
      [R.equals("Telefone"), _ => <td>{atendimento.Telefone}</td>],
      [R.equals("Vendedor"), _ => <td>{atendimento.Vendedor}</td>],
      [R.equals("Cliente"), _ => <td>{atendimento.Cliente}</td>],
      [R.equals("Atividade"), _ => <td>{atendimento.Atividade}</td>],
      [R.equals("Motivo"), _ => <td>{atendimento.Motivo}</td>],
      [R.equals("Texto"), _ => <td>{atendimento.Texto}</td>],

    ])

    return fn(nomeColuna)
  }

  useEffect(() => {
    setCarregadoVendedor(false)
  }, [props.vendedores])

  const novoButton = (
    <button
      className={`no-global-button ${estiloBotoes.botaoPrimario}`}
      id="Atendimento_NovoButton"
      onClick={() => props.onNovo()}
    >
      Novo
    </button>
  )

  return (
    <>
      <Separador />

      <div className="_flex _my-2">
        <label className="_text-right _w-[160px] _font-normal _mb-0 _cursor-pointer _mr-3"
          htmlFor="Atendimento_SomenteNaoLidos_Checkbox">Somente Não Lidos</label>
        <input
          className="_ml-3"
          type="checkbox"
          name="SomenteNaoLidos"
          id="Atendimento_SomenteNaoLidos_Checkbox"
          checked={formik.values?.SomenteNaoLidos ?? false}
          onChange={(e) => {
            formik.setFieldValue("SomenteNaoLidos", e.target.checked);
          }}
        />
      </div>

      <div className="_flex _my-2">
        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data Inicial</label>
        <InputData
          id="Atendimento_DataInicial_Input"
          className={`_w-[200px] ${formularioValidado && formik.errors.DataInicial != undefined && estiloInputs.inputComErro}`}
          data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataInicial)}
          onChange={(e) => formik.setFieldValue("DataInicial", e)}
          selecionaValorOnFocus
        />
      </div>

      <div className="_flex _my-2">
        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Data Final</label>
        <InputData
          id="Atendimento_DataFinal_Input"
          className="_w-[200px]"
          data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataFinal)}
          onChange={(e) => formik.setFieldValue("DataFinal", e)}
          selecionaValorOnFocus
        />
      </div>

      <div className="_flex _my-2">
        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Vendedor</label>

        <SelecaoComFiltro
          classNameIconeSeta="_w-[10px] _text-gray-500 _mr-[4px]"
          classNameInput="_w-[200px]"
          itens={carregandoVendedor ? [{ chave: "", valor: "Buscando..." }] : (props.vendedores ?? []).map(vendedor => ({
            chave: vendedor.Codigo.toString(),
            valor: vendedor.Nome
          }))}
          onValorModificado={(vendedor) => (setCarregadoVendedor(true), props.onPesquisarVendedor(vendedor))}
          onItemSelecionado={item => {
            formik.setFieldValue("CodigoVendedor", (props?.vendedores ?? []).find(b => b.Codigo.toString() == item.chave)?.Codigo.toString())
          }}
          itemSelecionado={{
            chave: formik.values.CodigoVendedor,
            valor: formik.values.CodigoVendedor && props.vendedores.length == 0 ? props.vendedorLogado?.Nome : (props?.vendedores ?? []).find(b => b.Codigo.toString() == formik.values.CodigoVendedor)?.Nome
          }}
          onLimpar={() => formik.setFieldValue("CodigoVendedor", null)}
          exibirIconeLimpar={true}
          filtroManual={true}
          placeholder="Digite 1 ou mais caracteres"
        />
      </div>

      <div className="_flex _my-2">
        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3" >Data Inicial Próx. Contato</label>
        <InputData
          id="Atendimento_DataInicialProximoContato_Input"
          className={`_w-[200px] ${formularioValidado && formik.errors.DataInicialProximoContato != undefined && estiloInputs.inputComErro}`}
          data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataInicialProximoContato)}
          onChange={(e) => {
            console.log(e)
            formik.setFieldValue("DataInicialProximoContato", e)
          }}
          selecionaValorOnFocus
        />
      </div>
      <div className="_flex _my-2">
        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3" >Data Final Próx. Contato</label>
        <InputData
          id="Atendimento_DataFinalProximoContato_Input"
          className="_w-[200px]"
          data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataFinalProximoContato)}
          onChange={(e) => formik.setFieldValue("DataFinalProximoContato", e)}
          selecionaValorOnFocus
        />
      </div>

      <div className="_flex _my-2">
        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3" >Cliente</label>
        <input
          readOnly
          disabled // sempre fica desabilitad
          title="Clique na lupa para pesquisar o cliente"
          placeholder="Clique na lupa para pesquisar"
          className="_w-[280px]"
          name="NomeCliente"
          id="Atendimento_NomeClienteInput"
          value={formik.values.NomeCliente ?? ''}
        />

        {props.possuiCliente && (
          <>
            <FontAwesomeIcon
              className="material-icons _mx-3 _w-[18px] _cursor-pointer _text-[#3c8ac9]"
              icon={faSearch}
              onClick={() => props.onPesquisarCliente(formik.values)}
            />
            <FontAwesomeIcon
              className="material-icons _w-[18px] _cursor-pointer _text-[#f25713]"
              icon={faTimesCircle}
              onClick={() => {
                formik.setFieldValue("NomeCliente", "")
                props.onLimparCliente()
              }}
            />
          </>
        )}

      </div>

      <div className="_flex _my-2">
        <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3" >Ordenação</label>
        <select
          className="_w-[200px]"
          multiple={false}
          name="Ordenacao"
          id="Atendimento_OrdenacaoSelect"
          onChange={(e) => formik.setFieldValue("Ordenacao", e.target.value)}
          value={formik.values.Ordenacao ?? ''}
        >
          {props.ordenacao?.map((value) => (
            <option key={value.Value} value={value.Value}>
              {value.Description}
            </option>
          ))}
        </select>
      </div>

      <div className="_mb-4 _mt-6">
        <button
          id="Atendimento_PesquisarButton"
          onClick={async () => {
            const erros = await formik.validateForm(formik.values)

            Object.keys(erros).length == 0 ? props.onPesquisar(formik.values) : props.onErrorValidacao(erros)

            setFormularioValidado(true)

          }}
          className={`no-global-button _mr-4 ${estiloBotoes.botaoPrimario}`}
        >
          Pesquisar
        </button>

        {props.permiteIncluirAtendimento && ( // 489353
          props.foraOrcamento
            ? <TooltipMU 
                  title="Para criar um atendimento associado a um pedido, acesse o pedido vá no Cliente/Consultas e clique em 'Atendimento'"
                >
                  {novoButton}
                </TooltipMU>
            : novoButton
        )}

      </div>

      {props.dadosAtendimento?.Entities?.length > 0 && (
        <div className="_mb-3">

          <AcoesHeadAtendimento
            onToggleColunaSelecionada={props.onColunaSelecionada}
            onAlterarFonte={props.onAlterarFonte}
            tamanhoFonte={props.tamanhoFontePadrao}
            colunas={props.colunas}
            onToggleSelecionarTodasColunas={props.onSelecionarTodasColunas}
            permiteEngrenagemGrid={props.permiteEngrenagemGrid ?? false} // 418506
          />



          <div className={estiloTabela.containerRolavel}>
            <table className={`_table _w-full _border-collapse ${estiloTabela.tabela}`}>

              <HeaderAtendimento colunas={props.colunas} />

              <tbody className="_table-row-group"
                id="Atendimento_TabelaAtendimentoTbody"
              >
                {
                  props.dadosAtendimento?.Entities?.map((atendimento) => (
                    <tr className={`_table-row ${estiloTabela.linhaClicavel}`}
                      id={`Atendimento_Linha_${atendimento.Codigo}`}
                      key={atendimento.Codigo}
                    >
                      {props.colunas.filter(c => c.Selecionada && c.Permitido).map(coluna => {
                        const cell = itensAtendimento({ nomeColuna: coluna.Nome, atendimento })
                        return React.isValidElement(cell)
                          ? React.cloneElement(cell as React.ReactElement<any>, { key: coluna.Nome })
                          : null
                      })}
                    </tr>
                  ))
                }
              </tbody>

            </table>
          </div>
        </div>
      )}


      {props.dadosAtendimento?.PageCount > 1 && (
        <Paginacao
          totalPaginas={props.dadosAtendimento?.PageCount}
          paginaAtual={props.dadosAtendimento?.ActualPage ?? null}
          id="Atendimento_Paginacao"
          onAlterarListaSelecionada={(numeroPagina) => props.onPesquisar({ ...formik.values, NumeroPagina: numeroPagina })}
        />
      )}
      <section style={{ marginBottom: "100px" }} />
    </>

  );
};
